// extracted by mini-css-extract-plugin
export default {"title":"VerifyIdentity_title__12RMk","peida":"VerifyIdentity_peida__SP3sK","logoImg":"VerifyIdentity_logoImg__PsJeE"};